var map = {
	"./cny-flower.png": 2553,
	"./paper.png": 2554,
	"./prize-1-bm.webp": 2555,
	"./prize-1-cn.webp": 2556,
	"./prize-1.webp": 2557,
	"./prize-2-bm.webp": 2558,
	"./prize-2-cn.webp": 2559,
	"./prize-2.webp": 2560,
	"./prize-3-bm.webp": 2561,
	"./prize-3-cn.webp": 2562,
	"./prize-3.webp": 2563,
	"./prize-4-bm.webp": 2564,
	"./prize-4-cn.webp": 2565,
	"./prize-4.webp": 2566,
	"./prize-5-bm.webp": 2567,
	"./prize-5-cn.webp": 2568,
	"./prize-5.webp": 2569,
	"./star.svg": 2570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 903;